<script lang="ts" setup>
import type ResponseData from '@/types/ResponseData'
import CompanyDataService from '@/services/CompanyDataService'
import type Company from '@/types/Company'
import { toast } from 'vue3-toastify'
import 'vue3-toastify/dist/index.css'
import { onMounted, ref, computed } from 'vue'
import store from '@/store'
import { Card, CardHeader, CardContent, CardFooter } from '@/components/ui/card'
import { Input } from '@/components/ui/input'
import { Badge } from '@/components/ui/badge'

const currentOrder = computed(() => store.state.currentOrder)
const currentCompany = ref({} as Company)

async function getCompany(id: any) {
  await CompanyDataService.getCompanyById(id)
    .then((response: ResponseData) => {
      currentCompany.value = response.data.data
    })
    .catch((e: Error) => {
      toast.error('Chyba: ' + e.message)
    })
}

async function refreshData() {
  await getCompany(currentOrder.value.company_id)
}

onMounted(async () => {
  await refreshData()
})
</script>

<template>
  <Card class="max-w-lg mx-auto flex flex-col gap-6">
    <CardHeader class="flex items-center gap-3 mb-2 border-b border-gray-200 pb-3 dark:border-gray-800">
      <svg class="size-7 text-brand-500" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" aria-hidden="true">
        <rect x="3" y="7" width="18" height="10" rx="2" stroke="currentColor" stroke-width="2" fill="none" />
        <path d="M7 7V5a5 5 0 0 1 10 0v2" stroke="currentColor" stroke-width="2" fill="none" />
        <path d="M8 15h8" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
      </svg>
      <span class="text-2xl font-bold text-gray-900 tracking-tight dark:text-white/90">Bizinix Doklady</span>
      <span class="ml-auto flex items-center gap-1">
        <Badge variant="light" color="primary" class="text-lg font-semibold">
          {{ currentOrder.amount }}€ <span class="text-xs font-normal text-gray-500 dark:text-gray-400">/ rok</span>
        </Badge>
        <svg class="size-4 text-gray-400" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24" aria-hidden="true">
          <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="1.5" fill="none" />
          <path d="M12 8v4m0 4h.01" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
        </svg>
      </span>
    </CardHeader>
    <CardContent class="flex flex-col gap-2">
      <div class="flex flex-col gap-2">
        <label for="zaplatenedo" class="block text-sm font-medium text-gray-700 dark:text-gray-300">Balík zaplatený do:</label>
        <Input
          id="zaplatenedo"
          v-model="currentCompany.fakturacia_zaplatene_do"
          aria-label="Dátum do ktorého je balík zaplatený"
        />
      </div>
    </CardContent>
    <CardFooter class="flex justify-end mt-2">
      <span class="text-xs text-gray-500 italic dark:text-gray-400">Údaje sú aktualizované podľa poslednej fakturácie.</span>
    </CardFooter>
  </Card>
</template>